export { default } from './SidebarCompactTitle';



// WEBPACK FOOTER //
// ./app/components/borrowing/sidebar/SidebarCompactTitle/index.js